module.exports = __webpack_public_path__ + "static/img/客户墙00019.14e4515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/客户墙00019.png
// module id = Xn0p
// module chunks = 1